<template>
  <div class="addSite form-box common-form-content">
    <el-form :model="formData" ref="form" :inline="false" size="normal">
      <div class="form-content" style="margin-bottom: 0.3rem;">
        <el-form-item label="站点名称" required>
          <el-input
              v-model="formData.plotName"
              placeholder="请输入站点名称"
              size="normal"
              clearable
              maxlength="30"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="所属地区" class="address_form-item" required>
          <el-select
              v-model="area"
              placeholder="省/市/区"
              @focus="areaSelect('county')"
              style="width: 100%;"
          >
            <i
                class="el-icon-arrow-right el-input__icon"
                slot="suffix">
            </i>
          </el-select>
        </el-form-item>
        <el-form-item label="位置选择" class="address_form-item" required>
          <div class="address-click">
            <div class="click-field" @click="showPopup = true"></div>
            <el-select
                style="width: 100%;"
                v-model="mapSearchWorld"
                placeholder="选择位置"
                disabled>
              <i
                  class="el-icon-arrow-right el-input__icon"
                  slot="suffix">
              </i>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item class="upload-form" label="门头照片" required>
          <div class="upload-box" @click.stop="handleChooseModel(true)">

            <el-image
                class="fileUrl"
                fit="cover"
                v-if="fileUrl"
                :src="fileUrl"></el-image>
            <div class="uploader-icon" v-else>
              <i class="el-icon-plus"></i>
            </div>
            <el-upload

                style="height: 0"
                class="avatar-uploader"
                :action="uploadUrl"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
                method="post"
                enctype="multipart/form-data"
                :data="{ business: 'advert' }"
                :headers="{ token: token }"
            >
              <div ref="upload"></div>
            </el-upload>
          </div>
        </el-form-item>
      </div>
      <div class="form-content">
        <el-form-item class="textarea-item" label="停车信息" required>
          <el-input
              type="textarea"
              :rows="2"
              resize="none"
              placeholder="请输停车收费情况"
              v-model="formData.parkCarInfo"
              maxlength="50"
              show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item class="nav-form-item radio-group" label="停车收费类型" required>
          <el-radio-group v-model="formData.parkCarStatus">
            <el-radio :label="0">停车收费</el-radio>
            <el-radio :label="1">停车免费</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item class="nav-form-item radio-group invoice" label="开发票" required>
          <el-radio-group v-model="formData.receiptStatus">
            <el-radio :label="0">不可以</el-radio>
            <el-radio :label="1">可以</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item class="nav-form-item radio-group invoice" label="是否支持预约" prop="appointmentStatus">
          <el-radio-group v-model="formData.appointmentStatus">
            <el-radio label="0">不支持</el-radio>
            <el-radio label="1">支持</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="formData.appointmentStatus == 1"
          class="nav-form-item radio-group invoice"
          label="锁桩时间"
          prop="lockTime"
        >
          <el-input
            v-model.number="formData.lockTime"
            placeholder="请输入锁桩时间(单位：小时)"
            type="Number"
            clearable
            maxlength="5"
            oninput="value=value.replace(/[^\d.]/g, '')"
          />
        </el-form-item>
        <el-form-item
          v-if="formData.appointmentStatus == 1"
          class="nav-form-item radio-group invoice"
          label="锁单保证金"
          prop="lockMargin"
        >
          <el-input
            v-model.number="formData.lockMargin"
            placeholder="请输入锁单保证金/元"
            type="Number"
            clearable
            maxlength="6"
            oninput="value=value.replace(/[^\d.]/g, '')"
          />
        </el-form-item>
        <el-form-item class="nav-form-item radio-group checkbox-group" label="配套设施" required>
          <el-checkbox-group v-model="formData.supportingFacilitiesList">
            <el-checkbox :label="1">免费WIFI</el-checkbox>
            <el-checkbox :label="2">便利店</el-checkbox>
            <el-checkbox :label="3">洗车</el-checkbox>
            <el-checkbox :label="4">厕所</el-checkbox>
            <el-checkbox :label="5">热水</el-checkbox>
            <el-checkbox :label="6">休息室</el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item class="nav-form-item radio-group invoice" label="负责人">
          <el-input
              v-model="formData.contactPeople"
              placeholder="请输入负责人名称"
              size="normal"
              clearable
              maxlength="6"
          >
          </el-input>
        </el-form-item>

        <el-form-item class="nav-form-item radio-group invoice" label="联系电话">
          <el-input
              v-model="formData.contactPhone"
              placeholder="请输入负责人联系电话"
              size="normal"
              clearable
              maxlength="11"
              oninput="value=value.replace(/[^\d]/g,'')"
          >
          </el-input>
        </el-form-item>

        <el-form-item class="nav-form-item radio-group invoice" label="运营状态">
          <el-radio-group v-model="formData.runningStatus">
            <el-radio :label="'0'">停业</el-radio>
            <el-radio :label="'1'">在营</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item class="nav-form-item radio-group invoice" label="小程序显示">
          <el-radio-group v-model="formData.showFlag">
            <el-radio :label="'0'">隐藏</el-radio>
            <el-radio :label="'1'">显示</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item class="nav-form-item radio-group invoice" label="充电站类型" prop="plotTypeName">
           <el-select
              v-model="formData.plotTypeCode"
              placeholder="请选择"
              @focus="showPicker=true"
              style="width: 100%;"
          >
          </el-select>

        </el-form-item>

        <el-form-item class="nav-form-item radio-group invoice" label="站点运营时间" prop="runningPeriod">
           <div style="display: flex;align-items: center;">
              <el-time-select placeholder="开始时间" v-model="formData.runningPeriodStart" :picker-options="{
                  start: '00:00',
                  step: '00:10',
                  end: '24:00',
                }" 
               @click.native="runningPeriodStart"
                style="width: 88px"></el-time-select>-
                <el-time-select placeholder="结束时间" v-model="formData.runningPeriodEnd" :picker-options="{
                  start: '00:00',
                  step: '00:10',
                  end: '24:00',
                }" 
               @click.native="runningPeriodEnd"
                style="width: 100px"></el-time-select>
            </div>
        </el-form-item>
          
      </div>


      <div class="form-sub-box">
        <div class="submit-btn" :class="{'is-submit-state': mixin_submitBtnState}" @click="onSubmit">
          保存
        </div>
      </div>
    </el-form>

    <nut-actionsheet class="action-sheet" :is-visible="areaShow">
      <div slot="custom">
        <van-area
            title="选择地区"
            :area-list="areaList"
            @confirm="confirm"
            @cancel="cancel"
        />
      </div>
    </nut-actionsheet>


    <qq-map
        v-model="showPopup"
        @placeChoose="placeChoose"
        :defaultObj="defaultObj"
    ></qq-map>


    <ChooseImage :visible="chooseVisible" :options="options"
                 @close="handleChooseModel(false)"
                 @click="handleClickOptionsItem"></ChooseImage>

    <nut-picker
        :is-visible="showPicker"
        :list-data="plotTypeList"
        @close="showPicker=false"
        @confirm="confirmPlotType"
    ></nut-picker>            

    <van-action-sheet v-model="datePickerVisible" :title="''">
      <van-datetime-picker
          type="time"
          title="选择时间"
          :min-hour="startHour"
          :max-hour="endHour"
          @confirm="dateChoose"
          @cancel="switchPicker"
          :filter="timeFilter"
          v-model="currentTime"
      />
    </van-action-sheet>


  </div>
</template>
<script>
import {areaList} from "@vant/area-data";
import {addPlot, editPlot, getPlotTypeList} from "@/api/newApi";
import {Toast} from "vant";
import "vant/lib/toast/style/index";
import Vue from "vue";
import {Area} from "vant";
import base from "@/utils/base";
import QqMap from "./qqMap.vue";
import ChooseImage from "@/components/choose-image/index.vue";
import {validate} from "@/mixins/mixin";

Vue.use(Area);
export default {
  components: {
    QqMap,
    ChooseImage
  },
  mixins: [validate],
  data() {
    return {
      chooseVisible: false,
      options: [
        {
          icon: require('@/assets/image/icon/album.png'),
          name: "相册"
        },
        // {
        //   icon: require('@/assets/image/icon/camera.png'),
        //   name: "拍摄"
        // },
      ],
      showPopup: false,
      formData: {
        plotName: "",
        address: "",
        fileId: "",
        parkCarInfo: "",
        lng: "",
        lat: "",
        province: "",
        regionName: "",
        city: "",
        cityCode: "",
        regionCode: null,
        parkCarStatus: "",
        receiptStatus: "",
        supportingFacilitiesList: [],
        contactPeople:'',
        contactPhone:'',
        runningStatus:'',
        showFlag:'',
        plotTypeCode:'',
        runningPeriodStart:'',
        runningPeriodEnd:'',
      },
      form: {
        county: "",
      },
      area: "",
      areaList: areaList,
      areaShow: false,
      defaultObj: {
        mapSearchWorld: ""
      },
      imgList1: [],
      token: "",
      mapSearchWorld: "",
      fileUrl: "",
      rules: {
        plotName: [
          {required: true, message: "请输入站点名称", trigger: "blur"},
          {
            min: 3,
            max: 10,
            message: "长度在 3 到 10 个字符",
            trigger: "blur",
          },
        ],
      },
      uploadUrl: "",
      lockTimeDIsplay: true,
      lockMarginDIsplay: true,
      lockTimeList:[{
        name: '1小时',
        id: '1'
      },{
        name: '2小时',
        id: '2'
      },{
        name: '3小时',
        id: '3'
      }],
      lockMarginList:[{
        name: '5元',
        id: 5
      },{
        name: '15元',
        id: 15
      },{
        name: '20元',
        id: 20
      }],
      plotTypeList:[],
      showPicker:false,
      datePickerVisible: false,
      startHour: 0,
      endHour: 24,
      currentTime:'',
      curDateType:'',
    };
  },
  watch: {},
  mounted() {
    this.token = window.localStorage.getItem("token");
    this.uploadUrl = base.bd + "/file/uploadImg";
    if (this.$route.query.id) {
      this.formData = this.$route.query;

      this.formData.runningPeriodStart = this.$route.query.runningPeriod != null ? this.$route.query.runningPeriod.split("-")[0].trim() : "";
      this.formData.runningPeriodEnd = this.$route.query.runningPeriod != null ? this.$route.query.runningPeriod.split("-")[1].trim() : "";

      this.formData.parkCarStatus =
          Number(this.$route.query?.parkCarStatus) || 0;
      this.formData.receiptStatus =
          Number(this.$route.query?.receiptStatus) || 0;
      this.formData.supportingFacilitiesList =
          (this.$route.query?.supportingFacilities &&
              this.$route.query?.supportingFacilities
                  .split(",")
                  .map((item) => Number(item))) ||
          [];
      this.area = `${this.formData["province"]} ${this.formData["city"]} ${this.formData["regionName"]}`;
      this.fileUrl = this.$route.query.fileUrl;
      this.mapSearchWorld = this.$route.query?.address;
      this.defaultObj = {
        id: "",
        mapSearchWorld: this.mapSearchWorld,
        city: this.formData.city,
        district: this.formData.regionName,
        province: this.formData.province,
        location: `${this.$route.query.lat},${this.$route.query.lng}`,
        addressLocal: this.$route.query?.address,
      };
    }

    this.getPlotTypeList();
  },
  methods: {
    getPlotTypeList() {
      let params = {
        parentCode: 'plotType',
      }
      getPlotTypeList(params).then((res) => {
        this.plotTypeList = [
           res.data.map((item) => {
            return {
              label: item.code,
              value: item.codeName,
            };
          })
        ];

      });
    },
    lockMarginClick(e){
      this.postForm.lockMargin = '';
      this.lockMarginDIsplay = e === 'true';
    },
    lockTimeClick(e){
      this.postForm.lockTime = '';
      this.lockTimeDIsplay = e === 'true';
    },
    handleChooseModel(visible) {
      this.chooseVisible = visible;
    },
    handleClickOptionsItem({item, index}) {
      if (index == 0) {
        this.$refs.upload.click()
      } else {
        alert("暂无功能")
      }
      this.handleChooseModel(false)
    },
    placeChoose(data) {
      this.defaultObj = {
        ...data,
        location: `${data.latitude},${data.longitude}`,
        addressLocal: data.area + data.address,
      };
      this.formData.lat = data.latitude;
      this.formData.lng = data.longitude;
      this.mapSearchWorld = data.area + data.address;
    },
    handleAvatarSuccess(res, file) {
      this.formData.fileId = res.data.imgID;
      this.fileUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = ["image/jpeg", "image/png"].includes(file.type);
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        Toast("上传图片只能是 JPG / PNG格式!");
      }
      if (!isLt2M) {
        Toast("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    areaSelect() {
      this.areaShow = !this.areaShow;
    },
    confirm(data) {
      this.formData["province"] = data[0].name;
      this.formData["city"] = data[1].name;
      this.formData["cityCode"] = data[1].code;
      this.formData["regionCode"] = data[2].code;
      this.formData["regionName"] = data[2].name;
      this.areaShow = !this.areaShow;
      // this.mapSearchWorld = ` ${this.formData["city"]} ${this.formData["regionName"]}`;
      this.defaultObj.mapSearchWorld = `${this.formData["city"]} ${this.formData["regionName"]}`;
      this.area = `${this.formData["province"]} ${this.formData["city"]} ${this.formData["regionName"]}`;
    },
    cancel() {
      this.areaShow = !this.areaShow;
    },
    onCancel() {
      this.$router.replace({
        path: "/admin/site",
      });
    },
    onSubmit() {
      this.formData.address = this.mapSearchWorld;
      if(!this.formData.parkCarInfo){
          this.formData.parkCarInfo = '暂无停车信息，以实际收费为准';
      }

      for (const key in this.formData) {
        if (this.formData[key] === "" && key != "plotCode" && key != "supportingFacilities") {
          console.log("key", key);
          Toast("请将信息填写完整后提交");
          return;
        }
      }

      //验证手机号格式是否正确
      if(this.formData.contactPhone){
        const phoneReg = /^1[3456789]\d{9}$/;
        if (!phoneReg.test(this.formData.contactPhone)) {
          Toast("联系电话格式不正确");
          return;
        } 
      }

      this.formData.runningPeriod = this.formData.runningPeriodStart.trim() + " - " + this.formData.runningPeriodEnd.trim();

      if (this.$route.query.id) {
        editPlot(this.formData).then((res) => {
          if (res.message.status == 200) {
            Toast("修改成功");
            this.$router.replace({
              path: "/admin/site",
            });
          }
        });
      } else {
        addPlot(this.formData).then((res) => {
          if (res.message.status == 200) {
            Toast("添加成功");
            this.$router.replace({
              path: "/admin/site",
            });
          } else {
            Toast(res.message.message)
          }
        });
      }
    },
    confirmPlotType(even) {
      this.formData.plotTypeCode = even[0].value;
      this.showPicker = false;
    },
    dateChoose(e) {
      console.log(e);
      this.datePickerVisible = false;
      if(this.curDateType == 'runningPeriodStart'){
          this.formData.runningPeriodStart = e.trim();
      }

      if(this.curDateType == 'runningPeriodEnd'){
          this.formData.runningPeriodEnd = e.trim();
      }

    },
    switchPicker() {
      this.datePickerVisible = false;
    },
    timeFilter(type, options) {
      return options.filter((option) => {
        if (type === "minute") {
          return option == 0 || option == 10 || option == 20 || option == 30 || option == 40 || option == 50;
        } else if (type === "hour") {
          return option;
        }
      });
      return options;
    },
    runningPeriodStart(){
      this.datePickerVisible = true;
      this.curDateType ="runningPeriodStart";
    },
    runningPeriodEnd(){
      this.datePickerVisible = true;
      this.curDateType ="runningPeriodEnd";
    },


  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/sass/state.scss";

.input-icon_box {
  display: flex;
  height: 100%;
  padding-right: 0.12rem;

}

.addSite {
  position: relative;
  background-color: #F5F5F6;

  .address_form-item {
    ::v-deep .el-select {
      .el-icon-arrow-up:before {
        content: "\e6de";
      }
    }
  }

  .address-click {
    position: relative;
    flex: 1;

    .click-field {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 9999;
    }

    .address_icon {
      width: 0.4324rem;
      height: 0.4324rem;
      align-self: center;
    }
  }

  .upload-form {
    border-bottom: 0 !important;


    .upload-box {
      position: relative;
      margin-top: 0.2562rem;
      padding-bottom: 0.5rem;
      flex: 1;

      .image-icon {
        position: absolute;
        width: 0.4494rem;
        height: 0.3513rem;
        top: 0.15rem;
        right: 0.2rem;;
      }
    }

    ::v-deep .el-form-item__label {
      align-self: baseline;
      line-height: 0.7rem;
      margin-top: 0.2093rem;
    }

    ::v-deep .el-form-item__content {
      justify-content: flex-start;
    }

    .uploader-icon,
    .fileUrl {
      width: 1.7837rem;
      height: 1.7837rem;
      line-height: 1.7837rem;
      background-color: #F7F8FA;
      margin-left: 0.3rem;
      text-align: center;

      .el-icon-plus {
        color: #C9CDD4;
        font-size: 0.5135rem;
      }
    }
  }

  .form-content {
    .textarea-item {
      flex-wrap: wrap;

      ::v-deep .el-form-item__label {
        text-align: left;
        width: 100%;
      }

      ::v-deep .el-textarea__inner {
        padding: 0 0.3rem;
      }
    }

    .radio-group {
      ::v-deep .el-form-item__content {
        padding-left: 0.3rem;
      }

      ::v-deep .el-radio__inner,
      ::v-deep .el-checkbox__inner {
        width: 0.4864rem;
        height: 0.4864rem;
      }

      ::v-deep .is-checked .el-radio__inner::after {
        width: 0.1864rem !important;
        height: 0.1864rem !important;

      }

      ::v-deep .is-checked .el-checkbox__inner::after {
        width: 0.121rem !important;
        height: 0.1891rem !important;
        font-weight: bold;
        margin-top: 0.02rem;
        margin-left: 0.02rem;
        border-width: 2px !important;
      }

      ::v-deep .el-radio__label,
      ::v-deep .el-checkbox__label {
        padding: 0.2rem !important;
        color: #999999;
      }
    }

    .invoice,
    .checkbox-group {
      ::v-deep .el-form-item__label {
        width: 2.5675rem;
        text-align: left !important;
      }
    }

    .checkbox-group {
      ::v-deep .el-form-item__label {
        align-self: baseline;
        line-height: 0.7rem;
      }
    }
  }

}

.action-sheet {
  ::v-deep .van-picker__confirm,
  ::v-deep .van-picker__cancel {
    font-size: 0.4054rem;
    color: #165DFF;
  }

  ::v-deep .van-picker__title {
    color: #1D2129;
  }

  ::v-deep .van-ellipsis {
    font-size: 0.3783rem;
  }
}
</style>



<style>
.el-icon-time {
  display: none;
}  

.el-input--suffix .el-input__inner{
  padding-right: 0px;
}
</style>